module.exports = __webpack_public_path__ + "023513b5b1da1e86c479b43f57fd1d58.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/amplification/social-pinterest.png
// module id = 3284
// module chunks = 69